'use client'

import { observer } from 'mobx-react'
import React, { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FilterDrawer } from './FilterDrawer'
import { FilterChipsHeader } from './FilterChipsHeader'
import { PrintHeader } from './PrintHeader'
import { RootStoreContext } from '@stores/rootStore'
import { DateTime } from 'luxon'
import { LFButton, LFButtonColor, LFButtonType } from '@components/LFButton'
import { sendGaEvent } from '@services/utils'
import { FiltersButton } from '@app/_components/common/FiltersButton'

export const findDefaultSeason = (seasons) => {
  const now = DateTime.now()

  const sortedSeasons = [...seasons].sort((a, b) =>
    a.datetime > b.datetime ? 1 : -1
  )

  let targetSeason = sortedSeasons[0]
  for (const season of sortedSeasons) {
    if (season.datetime > now) break

    targetSeason = season
  }

  return targetSeason
}

export const getYearOption = (
  lang: string,
  year = DateTime.now().year.toString()
) => ({
  label: lang === 'th' ? (parseInt(year, 10) + 543).toString() : year,
  value: parseInt(year, 10).toString(),
})

export const OrganizationHeader: FC = observer(() => {
  const { userStore } = useContext(RootStoreContext)
  const { t } = useTranslation()
  const [showFilters, setShowFilters] = useState(false)

  return (
    <>
      <div
        className={`
          flex w-full shrink-0 flex-col items-center justify-between gap-y-2 border border-t-0
          border-r-0 border-l-0 border-silver px-0 pt-5 pb-[1.3rem]
          md:flex-row md:gap-y-0 md:px-10
          print:hidden
        `}
      >
        <h1
          className={`
            hidden w-full text-4xl font-medium text-secondary-300
            md:block
          `}
        >
          {t('Overview')}
        </h1>
        <div className="mr-0 ml-auto flex w-full justify-end gap-x-2">
          <FiltersButton setShowFilters={setShowFilters} />
          <LFButton
            type={LFButtonType.PRIMARY}
            color={LFButtonColor.MAIN}
            borderRadius="rounded-xl"
            padding="px-4 py-3"
            className={`
              my-1 w-full text-center
              lg:my-0 lg:w-1/2 lg:max-w-82
              print:hidden
            `}
            onClick={() => {
              window.print()
              sendGaEvent('download_report')
            }}
          >
            <img
              src={'/static/assets/download-report.svg'}
              className={`
                hidden fill-white
                sm:block
              `}
            />

            <p className="text-2xl font-thin whitespace-nowrap text-white">
              {t('downloadReport')}
            </p>
          </LFButton>
        </div>

        {showFilters && <FilterDrawer setShowFilters={setShowFilters} />}
      </div>

      <FilterChipsHeader />

      <PrintHeader />
    </>
  )
})
